import Vue from 'vue'
import OssImg from '@/components/OssImg.vue'

Vue.component('oss-img', OssImg)
